module.exports = __webpack_public_path__ + "img/tea.81fadb1d.svg";